export default __webpack_public_path__ + "locales/ro/EmbeddingPanel.json?hash=ab76f5be6ab7f525e6944b7ab3a46924";